import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import {
  Button,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";

import toast from "react-hot-toast";
import Select from "react-select";
import InstituteWidgetService from "../../../services/KangarooServices/Intelligence/InstituteWidgetService";
import UniversityService from "../../../services/KangarooServices/UniversityService";
import WidgetService from "../../../services/KangarooServices/Intelligence/WidgetService";
import { getLoggedInUser } from "../../../helpers/fakebackend_helper";
import DestinationService from "../../../services/KangarooServices/DestinationService";

const InstituteWidgetForm = ({ isOpen, toggle, selectedItem, fetchData }) => {
  console.log("🚀 ~ InstituteWidgetForm ~ selectedItem:", selectedItem);
  const authUser = getLoggedInUser();
  const isSuperAdmin = authUser.roles[0].includes("SuperAdmin");
  const isOnshoreAdmin = authUser.roles[0].includes("OnshoreAdmin");
  const isOffshoreAdmin = authUser.roles.includes("OffshoreAdmin");

  const isOnshorePage = isOnshoreAdmin ? true : isOffshoreAdmin ? false : null;
  const [mediaGroup, setMediaGroup] = useState([]);
  const [isAustralia, setIsAustralia] = useState();
  const [institutedata, setInstituteData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [widgetData, setWidgetData] = useState([]);
  const [filters, setFilters] = useState({
    destinationCountryId: null,
  });
  const [debouncedFilters, setDebouncedFilters] = useState(filters);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedFilters(filters);
    }, 500);
    return () => clearTimeout(timer);
  }, [filters]);
  const fetchCountryData = async () => {
    setLoading(true);
    try {
      const response = await DestinationService.getList();
      const australia = response?.find(
        (item) => item?.name === "AUSTRALIA" || item?.name === "Australia",
      );

      setIsAustralia(australia);
      setMediaGroup(response);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCountryData();
  }, []);
  const fetchWidgetData = async (page = 1, size = 1000) => {
    try {
      const response = await WidgetService.getList({
        isOnshore: isOnshorePage,
        page,
        pageSize: size,
      });
      setWidgetData(response.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchWidgetData();
  }, []);
  const formik = useFormik({
    initialValues: {
      universityIds: selectedItem?.universityId
        ? [String(selectedItem.universityId)]
        : [],

      widgetIds: Array.isArray(selectedItem?.widgets)
        ? selectedItem.widgets.map((w) => String(w.widgetId))
        : [],
    },

    enableReinitialize: true,

    onSubmit: async (values) => {
      try {
        if (selectedItem?.universityId) {
          await InstituteWidgetService.update(values);
          toast.success("Widgets updated successfully");
        } else {
          await InstituteWidgetService.create(values);
          toast.success("Widgets created successfully");
        }

        fetchData();
        toggle();
      } catch (error) {
        console.log(error);
        toast.error("Something went wrong!");
      }
    },
  });

  const fetchUniversityData = async () => {
    setLoading(true);
    try {
      const response = await UniversityService.getList({
        ...debouncedFilters,
      });
      setInstituteData(response);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchUniversityData();
  }, [debouncedFilters]);
  // const fetchUniversityData = async () => {
  //   setLoading(true);
  //   try {
  //     const response = await UniversityService.getList();
  //     setInstituteData(response);
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   fetchUniversityData();
  // }, []);

  const instituteOptions = institutedata.map((i) => ({
    value: String(i.id),
    label: i.name,
  }));

  // const widgetOptions = widgetData?.map((type) => ({
  //   value: type.id,
  //   label: type.name,
  // }));
  const widgetOptions = [
    ...widgetData?.map((type) => ({
      value: type.id,
      label: type.name,
    })),
    ...(selectedItem?.widgets?.map((w) => ({
      value: w.id,
      label: w.name,
    })) || []),
  ];
  const mediaGroupOptions = mediaGroup.map((group) => ({
    label: group.name,
    value: group.id,
  }));
  const handleMediaGroupChange = (selectedOption) => {
    setFilters((prev) => ({
      ...prev,
      destinationCountryId: selectedOption ? selectedOption.value : null,
    }));
  };

  useEffect(() => {
    if (isOnshoreAdmin && isAustralia?.id) {
      setFilters((prev) => ({
        ...prev,
        destinationCountryId: isAustralia.id,
      }));
    }
  }, [isAustralia, isOnshoreAdmin]);
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Assign institute</ModalHeader>
      <ModalBody>
        <form onSubmit={formik.handleSubmit}>
          {!isOnshoreAdmin && (
            <div className="mb-3">
              <Label>Destination Country</Label>

              <Select
                options={mediaGroupOptions}
                value={mediaGroupOptions.find(
                  (option) => option.value === filters.destinationCountryId,
                )}
                onChange={handleMediaGroupChange}
                placeholder="Select Destination"
                isClearable
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
              />
            </div>
          )}
          <div className="mb-3">
            <Label>Affiliate Insitute</Label>
            <Select
              isMulti
              options={instituteOptions}
              value={instituteOptions.filter((opt) =>
                formik.values.universityIds.includes(opt.value),
              )}
              onChange={(selected) =>
                formik.setFieldValue(
                  "universityIds",
                  selected ? selected.map((s) => s.value) : [],
                )
              }
              placeholder="Select affiliate institute"
            />
          </div>
          <div className="mb-3">
            <Label>Widget</Label>

            <Select
              isMulti
              options={widgetOptions}
              value={
                formik.values.widgetIds
                  .map((id) => widgetOptions.find((opt) => opt.value === id))
                  .filter(Boolean) // in case some IDs are missing
              }
              onChange={(selected) =>
                formik.setFieldValue(
                  "widgetIds",
                  selected ? selected.map((s) => s.value) : [],
                )
              }
              placeholder="Select widget"
            />
          </div>
          <div className="d-flex justify-content-end gap-3 mb-3">
            <button type="submit" className="btn btn-success">
              {selectedItem?.universityId ? "Update" : "Create"}
            </button>
            <button type="button" className="btn btn-danger" onClick={toggle}>
              Cancel
            </button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default InstituteWidgetForm;
